import { IntegratedListingAdSlot } from './integratedListingAdSlots';
import { AdSlotDevicePairProps } from './AdSlotDevicePair.types';

const AdSlotDevicePair = ({ route, index, uuid }: AdSlotDevicePairProps) => (
    <>
        <IntegratedListingAdSlot
            route={route}
            listingIndex={index}
            uuid={uuid}
        />
        <IntegratedListingAdSlot
            route={route}
            listingIndex={index}
            uuid={uuid + '_mob'}
            useMobileConfig
        />
    </>
);

export default AdSlotDevicePair;
